import { createBrowserRouter, Navigate } from "react-router-dom";
import Home from "../pages/home/home";
import LoginPage from "../pages/login/login";
import SignUp from "../pages/login/signUp";
import ErrorPage from "../pages/errorPage";
import SettingPage from "../pages/settings/settingPage";
import StaffPage from "../pages/staffs/staffPage";
import StaffDetails from "../pages/staffs/staffDetails.jsx";
import ProductPage from "../pages/product/productPage.jsx";
import CategoryPage from "../pages/category/categoryPage.jsx";
import CustomerPage from "../pages/customer/customerPage.jsx";
import CustomerDetails from "../pages/customer/customerDetails.jsx";
import QuotationPage from "../pages/quotation/quotationPage.jsx";
import QuotationDetails from "../pages/quotation/quotationDetails.jsx";
import BannerPage from "../pages/banner/bannerPage.jsx";
import ProtectedRoute, { AuthRedirect } from "./protectedRoute.jsx";
import ProductDetails from "../pages/product/productDetails.jsx";
import PurchaseOrderPage from "../pages/purchaseOrder/purchaseOrderPage.jsx";
import PurchaseOrderDetails from "../pages/purchaseOrder/purchaseOrderDetails.jsx";
import Dashboard from "../pages/dashboard/dashboard.jsx";
import CategoryDetails from "../pages/category/categoryDetails.jsx";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <AuthRedirect element={<LoginPage />} />,
  },
  {
    path: "/signup",
    element: <AuthRedirect element={<SignUp />} />,
  },
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "/dashboard",
        element: <ProtectedRoute element={<Dashboard />} />,
      },
      {
        path: "/product",
        element: <ProtectedRoute element={<ProductPage />} />,
      },
      {
        path: "/product/:id",
        element: <ProtectedRoute element={<ProductDetails />} />,
      },
      {
        path: "/category",
        element: <ProtectedRoute element={<CategoryPage />} />,
      },
      {
        path: "/category/:id",
        element: <ProtectedRoute element={<CategoryDetails />} />,
      },
      {
        path: "/staff",
        element: <ProtectedRoute element={<StaffPage />} />,
      },
      {
        path: "/staff/:id",
        element: <ProtectedRoute element={<StaffDetails />} />,
      },
      {
        path: "/customer",
        element: <ProtectedRoute element={<CustomerPage />} />,
      },
      {
        path: "/customer/:id",
        element: <ProtectedRoute element={<CustomerDetails />} />,
      },
      {
        path: "/quotation",
        element: <ProtectedRoute element={<QuotationPage />} />,
      },
      {
        path: "/quotation/:id",
        element: <ProtectedRoute element={<QuotationDetails />} />,
      },
      {
        path: "/sales-order",
        element: <ProtectedRoute element={<PurchaseOrderPage />} />,
      },
      {
        path: "/sales-order/:id",
        element: <ProtectedRoute element={<PurchaseOrderDetails />} />,
      },
      {
        path: "/banner",
        element: <ProtectedRoute element={<BannerPage />} />,
      },
      {
        path: "/settings",
        element: <ProtectedRoute element={<SettingPage />} />,
      },
    ],
  },
]);
